import { API } from '~apis/axios/instance';
import { CompanyModel } from '~models/company';
import { ResponseBaseWithData } from '~types/response';

export const createCompanyWorkspace = (request: CompanyModel.CreateCompanyRequest) => {
  return API.post<ResponseBaseWithData<{ accessToken: string; companyId: string }>>(
    '/api/v3/companies',
    {
      data: request,
    },
  );
};
